import { Link } from "react-router-dom";
import { MapPin, BadgeCheck, ArrowRight } from "lucide-react";

export const ProjectCard = ({ p, index = 0 }) => (
  <Link
    to={`/projects/${p.slug}`}
    data-testid={`project-card-${p.slug}`}
    style={{ animationDelay: `${index * 90}ms` }}
    className="group animate-fade-up block rounded-xl overflow-hidden bg-white border border-gray-100 shadow-[0_8px_32px_rgba(11,93,59,0.06)] hover:shadow-[0_16px_48px_rgba(11,93,59,0.14)] transition-shadow"
  >
    <div className="relative h-56 overflow-hidden">
      <img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      <span className="absolute top-3 left-3 flex items-center gap-1 rounded-full bg-white/95 px-2.5 py-1 text-[11px] font-semibold text-[#0B5D3B]">
        <BadgeCheck size={13} /> {p.approval} Approved
      </span>
      {p.status && <span className="absolute top-3 right-3 rounded-full bg-[#D4AF37] px-2.5 py-1 text-[11px] font-semibold text-black">{p.status}</span>}
    </div>
    <div className="p-5">
      <h3 className="font-heading font-semibold text-lg text-gray-900 group-hover:text-[#0B5D3B] transition-colors">{p.name}</h3>
      <p className="flex items-center gap-1.5 text-sm text-gray-500 mt-1"><MapPin size={14} /> {p.location}</p>
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100">
        <div>
          <p className="text-[11px] uppercase tracking-wide text-gray-400">Starting</p>
          <p className="font-heading font-bold text-[#0B5D3B]">{p.price}</p>
        </div>
        <span className="flex items-center gap-1 text-sm font-semibold text-[#0B5D3B]">View Details <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
      </div>
    </div>
  </Link>
);
